var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoVr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 149,
    height: 102,
    viewBox: "0 0 149 102",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Artboard_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 149,
    height: 102
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard_2",
    "data-name": "Artboard 2",
    clipPath: "url(#clip-Artboard_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_56",
    "data-name": "Group 56",
    transform: "translate(-2098 -1631.975)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_53",
    "data-name": "Group 53",
    transform: "translate(2098 1631.975)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52",
    "data-name": "Group 52",
    transform: "translate(13.907 40.942)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_50",
    "data-name": "Group 50"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M2619.948,2320.993a18.767,18.767,0,0,1,3.583.344,9.974,9.974,0,0,0-8.686-5.067h-79.881a9.974,9.974,0,0,0-8.686,5.067,18.766,18.766,0,0,1,3.583-.344Z",
    transform: "translate(-2514.562 -2316.27)",
    fill: "#c1272d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M2435.826,2449.656H2345.74a15.3,15.3,0,0,0-15.3,15.3v21.356a15.3,15.3,0,0,0,15.3,15.3h27.536c3.632,0,7.983-5.775,10.291-9.284a8.647,8.647,0,0,1,7.159-3.924h.115a8.646,8.646,0,0,1,7.159,3.924c2.308,3.509,6.659,9.284,10.291,9.284h27.536a15.3,15.3,0,0,0,15.3-15.3v-21.356A15.3,15.3,0,0,0,2435.826,2449.656Z",
    transform: "translate(-2330.44 -2441.676)",
    fill: "#c1272d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_51",
    "data-name": "Group 51",
    transform: "translate(4.072 11.564)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M2401.751,2523.133a10.332,10.332,0,0,1,10.332-10.332h19.148a1.628,1.628,0,0,0,1.629-1.629h0a1.629,1.629,0,0,0-1.629-1.629h-19.148a13.589,13.589,0,0,0-13.589,13.589v19.147a1.629,1.629,0,0,0,1.629,1.629h0a1.629,1.629,0,0,0,1.629-1.629v-19.147Z",
    transform: "translate(-2398.494 -2509.544)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M2238.321,1702.83c15.262-23.294,7.229-47.994-8.233-57.634-15.625-9.739-33.127-11.991-50.975-13.113-2.283-.144-11.445-.144-13.727,0h0c-17.847,1.122-35.348,3.374-50.973,13.113-15.462,9.64-23.495,34.339-8.234,57.634v-11.848c-3.814-5.422-5.333-7.538-5.008-11.673.361-4.617,4.182-12.4,8.375-17.052,9.129-10.121,23.676-14.863,36.8-16.8l.293-.043a177.283,177.283,0,0,1,51.23,0l.293.043c13.119,1.932,27.667,6.674,36.8,16.8,4.192,4.649,8.015,12.435,8.375,17.052.323,4.135-1.193,6.251-5.009,11.673Z",
    transform: "translate(-2098 -1631.975)",
    fill: "#c1272d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_54",
    "data-name": "Group 54",
    transform: "translate(2152.743 1687.505)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M3270.156,2560.685h-.842v-.583h2.324v.583h-.842v2.177h-.641Z",
    transform: "translate(-3253.976 -2560.101)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M3313.608,2560.1h.641v1.088h1.129V2560.1h.641v2.76h-.641v-1.088h-1.129v1.088h-.641Z",
    transform: "translate(-3295.62 -2560.101)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M3364.013,2560.1h2v.576h-1.36v.517h1.2v.567h-1.2v.525h1.4v.576h-2.041Z",
    transform: "translate(-3343.009 -2560.101)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M3013.871,2631.468v2.161h-.914v-4.08h.219l2.391,2.254V2629.6h.914v4.08h-.219Z",
    transform: "translate(-3012.957 -2625.394)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M3086.616,2630.32h2.925v.842h-1.989v.755h1.753v.83h-1.753v.766h2.046v.841h-2.983Z",
    transform: "translate(-3082.208 -2626.119)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M3147.982,2630.32h.937v4.034h-.937Z",
    transform: "translate(-3139.903 -2626.119)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M3176.022,2631.161a2.025,2.025,0,0,1,2.121-2.092,2.086,2.086,0,0,1,1.718.807l-.661.57a1.223,1.223,0,0,0-1.028-.513,1.139,1.139,0,0,0-1.2,1.216,1.172,1.172,0,0,0,1.2,1.262.918.918,0,0,0,1.017-.824h-1.155v-.8h2.034a1.569,1.569,0,0,1,.069.519,1.866,1.866,0,0,1-1.994,1.948A2.014,2.014,0,0,1,3176.022,2631.161Z",
    transform: "translate(-3166.266 -2624.943)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M3255.637,2630.32h.937v1.591h1.649v-1.591h.937v4.034h-.937v-1.591h-1.649v1.591h-.937Z",
    transform: "translate(-3241.117 -2626.119)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M3329.3,2630.32h1.833c.77,0,1.184.415,1.184,1.026a.975.975,0,0,1-.5.905v.023a.883.883,0,0,1,.684.922c0,.68-.459,1.158-1.333,1.158H3329.3Zm1.621,1.6c.276,0,.46-.144.46-.409s-.178-.386-.454-.386h-.69v.8Zm.132,1.625c.322,0,.511-.162.511-.427s-.184-.415-.506-.415h-.822v.842Z",
    transform: "translate(-3310.369 -2626.119)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M3389.894,2631.161a2.127,2.127,0,1,1,2.126,2.092A2.059,2.059,0,0,1,3389.894,2631.161Zm3.31,0a1.185,1.185,0,1,0-1.184,1.228A1.186,1.186,0,0,0,3393.2,2631.161Z",
    transform: "translate(-3367.342 -2624.943)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M3470.47,2632.683v-2.363h.937v2.351c0,.542.271.9.816.9s.816-.363.816-.9v-2.351h.937v2.363a1.753,1.753,0,0,1-3.505,0Z",
    transform: "translate(-3443.096 -2626.119)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M3543.361,2630.32h1.753c.96,0,1.529.479,1.529,1.3a1.236,1.236,0,0,1-.914,1.222l1.149,1.481v.029h-1.057l-.822-1.112a.537.537,0,0,0-.546-.282h-.155v1.395h-.937Zm1.69,1.862c.391,0,.644-.2.644-.513s-.253-.513-.644-.513h-.753v1.026Z",
    transform: "translate(-3511.626 -2626.119)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M3605.975,2632.694l.511-.732a1.943,1.943,0,0,0,1.207.433c.3,0,.557-.086.557-.334,0-.184-.132-.276-.563-.4l-.3-.092c-.85-.259-1.259-.651-1.259-1.3,0-.784.6-1.193,1.489-1.193a2.383,2.383,0,0,1,1.483.467l-.523.709a1.563,1.563,0,0,0-.971-.317c-.3,0-.511.086-.511.282,0,.213.293.317.816.5.96.34,1.3.669,1.3,1.285,0,.766-.523,1.251-1.557,1.251A2.646,2.646,0,0,1,3605.975,2632.694Z",
    transform: "translate(-3570.494 -2624.943)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_55",
    "data-name": "Group 55",
    transform: "translate(2127.856 1702.856)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M2597.015,2819.063h1.7l2.339,5.825,2.364-5.825h1.683l-3.628,8.427h-.812Z",
    transform: "translate(-2597.015 -2818.92)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M2751.627,2819.063h1.54v8.355h-1.54Z",
    transform: "translate(-2742.376 -2818.92)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M2811.476,2819.063h3.533a3.225,3.225,0,0,1,2.238.7,2.427,2.427,0,0,1,.77,1.892,2.529,2.529,0,0,1-.525,1.611,2.563,2.563,0,0,1-1.563.883l2.6,3.211v.06h-1.779l-1.922-2.483c-.1-.119-.181-.219-.257-.3a1,1,0,0,0-.245-.191.872.872,0,0,0-.292-.1,2.7,2.7,0,0,0-.388-.024h-.633v3.092h-1.54Zm3.438,3.963a1.613,1.613,0,0,0,1.146-.37,1.222,1.222,0,0,0,.394-.931,1.181,1.181,0,0,0-.394-.925,1.667,1.667,0,0,0-1.146-.352h-1.9v2.578Z",
    transform: "translate(-2798.645 -2818.92)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M2936.032,2820.471h-2.662v-1.408h6.864v1.408h-2.65v6.947h-1.552Z",
    transform: "translate(-2913.246 -2818.92)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M3069.194,2827.562a4.3,4.3,0,0,1-1.444-.232,3,3,0,0,1-1.122-.692,3.211,3.211,0,0,1-.728-1.128,4.192,4.192,0,0,1-.262-1.54v-4.906h1.54v4.906a2.283,2.283,0,0,0,.531,1.605,2.2,2.2,0,0,0,2.972,0,2.287,2.287,0,0,0,.531-1.605v-4.906h1.54v4.906a4.2,4.2,0,0,1-.263,1.54,3.208,3.208,0,0,1-.728,1.128,3,3,0,0,1-1.122.692A4.305,4.305,0,0,1,3069.194,2827.562Z",
    transform: "translate(-3037.599 -2818.92)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M3199.919,2817.467h.7l3.808,8.451h-1.671l-.573-1.3h-3.832l-.561,1.3h-1.683Zm1.73,5.9-1.373-3.151-1.385,3.151Z",
    transform: "translate(-3160.267 -2817.419)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M3353.717,2819.063h1.54V2826h3.963v1.42h-5.5Z",
    transform: "translate(-3308.442 -2818.92)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M3517.9,2819.063h1.54v3.449h3.987v-3.449h1.54v8.355h-1.54v-3.5h-3.987v3.5h-1.54Z",
    transform: "translate(-3462.806 -2818.92)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M3667.1,2825.311a4.515,4.515,0,0,1-1.731-.328,4.144,4.144,0,0,1-1.378-.907,4.244,4.244,0,0,1-.913-1.373,4.553,4.553,0,0,1,0-3.426,4.251,4.251,0,0,1,.913-1.373,4.163,4.163,0,0,1,1.378-.907,4.728,4.728,0,0,1,3.461,0,4.171,4.171,0,0,1,1.379.907,4.253,4.253,0,0,1,.913,1.373,4.553,4.553,0,0,1,0,3.426,4.246,4.246,0,0,1-.913,1.373,4.151,4.151,0,0,1-1.379.907A4.515,4.515,0,0,1,3667.1,2825.311Zm0-1.42a2.772,2.772,0,0,0,1.11-.221,2.676,2.676,0,0,0,.889-.615,2.9,2.9,0,0,0,.591-.925,3.135,3.135,0,0,0,0-2.28,2.853,2.853,0,0,0-.6-.925,2.776,2.776,0,0,0-3.987,0,2.842,2.842,0,0,0-.6.925,3.135,3.135,0,0,0,0,2.28,2.9,2.9,0,0,0,.591.925,2.673,2.673,0,0,0,.889.615A2.774,2.774,0,0,0,3667.1,2823.89Z",
    transform: "translate(-3598.978 -2816.669)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M3835.107,2818.863h.668l3.533,5.168,3.521-5.168h.68v8.367h-1.5v-4.906l-2.578,3.808h-.227l-2.6-3.808v4.906h-1.492Z",
    transform: "translate(-3761.031 -2818.731)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M4008.673,2819.063h5.909v1.4h-4.369v2.053h3.9v1.385h-3.9v2.125h4.488v1.4h-6.028Z",
    transform: "translate(-3924.213 -2818.92)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoVr);
export default __webpack_public_path__ + "static/media/logo-vr.ea58f912c5ecd168adafd3a7433f2e74.svg";
export { ForwardRef as ReactComponent };